import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/layout"

const IndexPage = ({ data }) => {
  const imgData = data.fileName.childImageSharp.fluid
  const author = "suga"
  const quote = `Good music will always be recognized in the end.`

  return <Layout imgData={imgData} author={author} quote={quote} />
}

export default IndexPage

export const query = graphql`
  query {
    fileName: file(relativePath: { eq: "suga5.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
